import React, { useState } from 'react'
import './lightning-support-page.css'
import supportImg from '../../../assets/img/support.svg'
import supportManWomanImg from '../../../assets/img/support-man-woman.svg'
import mailIcon from '../../../assets/img/mail-24px.svg'
import phoneIcon from '../../../assets/img/call-24px.svg'
import Card from "../../../components/card/Card";
import { useBranding } from "../../../branding/BrandingProvider";
import collectionArea from "../../../assets/img/Collection Area of WTG.png";
import collectionAreaTopography from "../../../assets/img/Collection-Area-Topography.png";
import DTM from "../../../assets/img/DTM.png";
import DTMSurface from "../../../assets/img/DTM-surface.png";
import confidence from "../../../assets/img/confidence-ellipse.png";
import confidenceCollection from "../../../assets/img/collection-araea-confidence-ellipse.png";
import Lightning_Density_map_2021 from '../../../assets/img/Global_lightning_density_2021.jpg'
import Lightning_Density_map_2016_2020 from '../../../assets/img/Average_global_lightning_density_2016_2020.jpg'
import termsUKEUROW from './termsUKEUROW'
import termsUS from './termsUS'


export default function LightningSupportPage(props) {
    const brand = useBranding();
    const [showFaq, setShowFaq] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showTermsUK, setShowTermsUK] = useState(false);
    const [showTermsUS, setShowTermsUS] = useState(false);

    if (!brand.showSupportContact) return <div className='support-page' />;

    return (<div className='support-page'>
        <h1>LASSIE Support Page</h1>
        <div className='split'>
            <div>
                <h1>Need support?</h1>
                <img src={supportImg} alt='support' />
                <p>If you need support when using LASSIE see beelow or please contact us.</p>
                <div>
                </div>
            </div>
            <div>
                <h1>Blade experts</h1>
                <img src={supportManWomanImg} alt='blade experts' className='icon-img' />
                <p>Do you need help or a second opinion of a lightning related damage? Our blade
                    experts are ready to help.</p>
            </div>
        </div>
        {brand.showSupportContact && <div className='split'>
            <div>
                <a href='mailto:contact@windpowerlab.com' className='call-to-action-btn'>
                    <img src={mailIcon} alt='contact-email' className='icon-img' />
                    <span>contact@windpowerlab.com</span>
                </a>
            </div>
            <div>
                <a href='mailto:contact@windpowerlab.com' className='call-to-action-btn'>
                    <img src={mailIcon} alt='contact-email' className='icon-img' />
                    <span>contact@windpowerlab.com</span>
                </a>
                <a href='tel:004530482448' className='call-to-action-btn'>
                    <img src={phoneIcon} alt='blade-phone' className='icon-img' />
                    <span>+45 30 482 448</span>
                </a>
            </div>
        </div>}
        <Card>
            <div onClick={() => setShowFaq(!showFaq)} className='header'>
                <h2>FAQ</h2>
                <div className='spacer' />
                {<span className='show-less-more'>Show {showFaq ? 'less -' : 'more +'}</span>}
            </div>
            <div className='faq-content' hidden={!showFaq}>

                <div>
                    <h4>What is lightning?</h4>
                    <p>
                        Lightning is an electrical discharge resulting from imbalances in electrical charge
                        between storm clouds and the ground or within the clouds themselves. Most lightning occurs within clouds.

                        During a storm, particles of rain, ice, or snow collide inside storm clouds,
                        increasing the imbalance of charges. This often leads to the lower portions of storm
                        clouds becoming negatively charged. This charge difference creates
                        an imbalance that nature corrects by allowing an electrical current to
                        flow between the oppositely charged areas.
                    </p>

                    <p>
                        Lightning is being divided into two main categories. In-Cloud lightning and Cloud to ground lightning.
                    </p>
                    <p>
                        <b>In Cloud lightning</b>:<br></br>
                        A cloud flash is lightning that connects regions with opposite polarity (+/-) within one cloud or between
                        multiple clouds. In-cloud lightning usually precedes cloud-to-ground lightning.
                    </p>

                    <b> Cloud-to-ground lightning</b>: <br></br>
                    A cloud-to-ground flash consists of at least one cloud-to-ground stroke and is dangerous to life
                    and property. A cloud-to-ground stroke, also known as a stroke, is lightning that connects a charge region in
                    a cloud to the ground and is the bright, high current, visible part of lightning that touches the ground or an object.
                    <p>
                        When lightning attaches to the wind turbine blade research shows that  the tip area of the blade is more prone to receive
                        lightning strikes than all other places on the blade. [1][2][3].
                    </p>
                </div>


                <div>

                    <h4>Lightning intensity at a global scale</h4>

                    <p>
                        The distribution of lightning on Earth is far from uniform. The ideal conditions for producing lightning
                        and associated thunderstorms occur where warm, moist air rises and mixes with cold air above.
                        These conditions occur almost daily in many parts of the Earth, but only rarely in other areas.
                    </p>

                    <h3>Global lightning density 2021</h3>
                    <img src={Lightning_Density_map_2021} alt={'Lightning Density map 2021'} class="center" />

                    <h3>Average global lightning density 2016–2020</h3>
                    <img src={Lightning_Density_map_2016_2020} alt={'Lightning Density map 2016'} class="center" />
                </div>

                <div>
                    <h4>Wind turbines and lightning</h4>

                    <p>
                        Wind turbines are equipped with a lightning protection system (LPS)
                        designed to significantly reduce the risks associated with lightning strikes.
                        This system works by safely directing the electrical energy from a strike down through the turbine structure and into the ground,
                        thereby protecting critical components such as the blades, nacelle, and generator from damage.
                    </p>

                    <p>
                        The LPS consist of several part such as lightning receptors on the blades, conductive paths that channel the electrical charge safely,
                        and grounding systems that disperse the energy into the earth.
                    </p>
                </div>

                <div>
                    <h4>What is the IEC 61400-24 standard</h4>

                    <p>
                        The International Standard 61400-24 governs the lightning protection of wind turbine generators.
                        It delineates the lightning environment specific to wind turbines and its application in risk
                        assessment for these installations.
                        Moreover, it outlines the prerequisites for safeguarding blades, structural elements,
                        and electrical as well as control systems from both direct and indirect lightning effects.
                    </p>
                </div>

                <div>
                    <h4>Why is the 61400-24 standard important?</h4>

                    <p>
                        The standard outlines the magnitude of lightning strikes
                        that the Lightning Protection System (LPS) must effectively manage.
                        It serves as a benchmark to determine whether a lightning strike falls within the design parameters of the LPS or surpasses them.
                    </p>

                    <p>
                        For first stroke:
                    </p>

                    <table className="table">
                        <tr>
                            <th>Peak Current</th>
                            <tr>-100 to 200 kA</tr>
                        </tr>

                        <tr>
                            <th>Average Steepness</th>
                            <tr>200 kA/µs</tr>
                        </tr>

                        <tr>
                            <th>Specific energy</th>
                            <tr>10 MJ/Ω</tr>
                        </tr>

                        <tr>
                            <th>Total charge</th>
                            <tr>300 C</tr>
                        </tr>
                    </table>
                    <p>
                        For subsequent strokes:
                    </p>
                    <table className="table">
                        <tr>
                            <th>Peak Current</th>
                            <tr>-50 to 50 kA</tr>
                        </tr>

                        <tr>
                            <th>Average Steepness</th>
                            <tr>200 kA/µs</tr>
                        </tr>

                    </table>

                    <h4>What are subsequent strokes, and how are they defined?</h4>
                    <p>
                        Subsequent strokes refer to all lightning strokes that occur after the initial (or "first") stroke in a lightning flash.
                        Flashes with many subsequent strokes often produce noticeable "flickering" of the lightning channel, which can be seen with the naked eye. The industry standard is to use a maximum interstroke interval of 500 ms [5].
                    </p>

                </div>

                <div>
                    <h4>Is a lightning strike outside the IEC certification limits?</h4>

                    <p>
                        LASSIE automatically monitors whether a lightning strikes peak current is the initial strike or a subsequent stroke,
                        while also verifying if it conforms to the certification limits of the LPS system
                    </p>
                </div>

                <div>
                    <h4>Interpreting the 2% Rule for wind turbine blade damages in the IEC Standard</h4>
                    <p>
                        The 2% damage rule in the IEC standard can be interpreted in various ways:

                        <ol>
                            <li>The 2% coefficient pertains to the efficiency of the Lightning Protection System (LPS) in a laboratory setting.</li>
                        </ol>

                        The consensus among the IEC 61400:24 committee, comprising lightning specialists from OEMs, universities, and test centers, is that the 2% statement
                        relates to the efficiency of the LPS system during the certification of a new blade. It does not directly apply to operational conditions.

                        Other interpretations of the 2% probability for LPS/LPL class I include:

                        <ol start="2">
                            <li>With a LPS/LPL class 1, there's a 2% chance of structural damage occurring.</li>
                        </ol>

                        This implies that out of 100 lightning strikes hitting a turbine or wind farm, approximately 2—regardless of their type or size—could cause structural damage.
                        This aligns more closely with reality than what we see in bullet 3, as LPS designs with a proven track record may experience lightning strikes outside of their receptors, resulting in structural damage.

                        <ol start="3">
                            <li>2% of all lightning strikes fall outside of the certification range.</li>
                        </ol>

                        However, it's improbable that 2% of all lightning strikes exceed the certification threshold, especially outside of specific regions.
                        In fact, data suggests that smaller lightning strikes, which are less predictable, are more likely to cause damage to a blade than larger ones.
                    </p>
                </div>

                <div>
                    <h4>Does the location of the wind turbine matter? </h4>

                    <p>
                        Yes it does. The IEC standard defines how the collection area should be defined on flat land or in more complex terrain.
                        On flat land the collection area is 3x the turbine height as can be seen below.
                        <img src={collectionArea} alt='collection-area' class="center" />
                    </p>

                </div>
                <div>
                    <p>
                        In more complex terrain, it is appropriate to consider the effective height of the wind turbine including the height
                        of the wind turbine position, e.g. if placed exposed on hills or ridges as shown below.
                    </p>

                    <img src={collectionAreaTopography} alt='collection-area-topography' class="center" />

                    <p>
                        LASSIE handles both scenarios and automatically calculates if a lightning strike is within the collection area of a turbine.
                        No matter if the wind turbine is located on flat land or an elevated position.

                        We are using a digital terrain model to support us in these calculations.
                    </p>
                </div>

                <div>
                    <h4>What is a Digital Terrain Model?</h4>

                    <p>
                        A Digital Terrain Model (DTM) is a detailed map showing just the natural shape of the ground without trees, buildings,
                        or other things on it, as depicted below.
                    </p>

                    <img src={DTM} alt='Digital Terrain Model' class="center" />

                    <p>
                        LASSIE is using a DTM made by NASA*. This DTM is very detailed, with measurements taken every 30 meters.
                        It means that within each square on the map, you get an average height above sea level.
                        The DTM represents this data in a digital grid format, removing anything that isn't part of the natural landscape.

                        <p>
                            * https://www.earthdata.nasa.gov/eosdis/daacs/lpdaac
                        </p>
                        An example of a DTM can be seen here:
                    </p>

                    <img src={DTMSurface} alt='Digital Terrain Model' class="center" />

                </div>

                <div>
                    <h4>What is the confidence ellipse?</h4>

                    <p>
                        The confidence ellipse is determined by three factors: its length from one end
                        to the other (semi-major length),
                        its shorter length (semi-minor length), and the angle it makes with true north.
                        The confidence ellipse is a statistical measure influenced by the accuracy of the
                        sensors detecting lightning strikes.
                        A smaller ellipse indicates more precise coverage by the network in the region.

                        LASSIE is operating with 99th percentile meaning that LASSIE expects that in 99% of
                        the time a lightning strike will fall within the P99 level and in 1% a lightning
                        will fall outside the 99th percentile.
                        Meaning that a lightning strike will fall outside the confidence ellipse.
                    </p>
                    <img src={confidence} alt='confidence ellipse' class="center" />

                </div>

                <div>
                    <h4>Probability?</h4>

                    <p>
                        The probability is determined by how much the collection area of he turbine overlaps
                        with the confidence ellipse of the lightning strike.

                    </p>
                    <img src={confidenceCollection} alt='confidence ellipse with collection area' class="center" />
                </div>


                <div>
                    <h4>How often is the data updated?</h4>

                    <p>
                        The data gets refreshed every hour, but during significant lightning events,
                        updates might be delayed.
                    </p>

                </div>

                <div>
                    <h4> Do you share my wind turbine information?</h4>

                    <p>All information and data handled in LASSIE is covered by
                        individual client agreements on confidentiality.
                        No data is being shared with 3rd party companies. </p>
                </div>
                <div>
                    <h4>References</h4>
                    <p>[1] Madsen, S. F. (2006), Interaction between electrical discharges and materials for wind
                        turbine
                        blades particularly related to lightning protection, PhD thesis, Ørsted-DTU, The Technical Univ.
                        of Denmark, Kongens Lyngby, Denmark.
                    </p>

                    <p>[2] Bertelsen, K., H. V. Erichsen, M. S. Jensen, and S. F. Madsen (2007), Application of
                        numerical models to
                        determine lightning attachment points on wind turbines, in Proceedings of the International
                        Conference on Lightning and Static Electricity, IET, pp. 28–31, Paris, France.
                    </p>

                    <p>[3] Garolera, A. C., S. F. Madsen, M. Nissim, J. Myers, and J. Holboell (2016), Lightning damage
                        to
                        wind turbine blades from wind farms in US, IEEE Trans. Power Delivery, 31(3), 1043–1049,
                        doi:10.1109/TPWRD.2014.2370682.
                    </p>

                    <p>
                        [4] IEC 61400-24 (2010): Wind energy generation systems - Part 24: Lightning protection
                    </p>

                    <p>
                        [5] Dieter R. P., Wolfgang S., Stephane P., Dustin H., Marcelo S., Hugh H., Lukas S., Christian V., Carlos T. M., Carina S., and Tom W., <i>Global
                        ground strike point characteristics in negative downward lightning flashes – Part 1: Observations </i>
                    </p>


                </div>
            </div>
        </Card>
        <Card>
            <div onClick={() => setShowTerms(!showTerms)} className="header">
                <h2>Terms and conditions</h2>
                <div className='spacer' />
                {<span className='show-less-more'>Show {showTerms ? 'less -' : 'more +'}</span>}
            </div>
            <div className='content terms' hidden={!showTerms}>
                <p className='terms-intro'>
                    Please select the version that applies to you. The US version applies to
                    customers contracting in the United States; the UK / Europe / Rest of World
                    version applies to all other customers.
                </p>

                <div className='terms-sub'>
                    <div onClick={() => setShowTermsUK(!showTermsUK)} className='header sub-header'>
                        <h3>UK / Europe / Rest of World</h3>
                        <div className='spacer' />
                        <span className='show-less-more'>Show {showTermsUK ? 'less -' : 'more +'}</span>
                    </div>
                    <div className='terms-doc' hidden={!showTermsUK}
                         dangerouslySetInnerHTML={{ __html: termsUKEUROW }} />
                </div>

                <div className='terms-sub'>
                    <div onClick={() => setShowTermsUS(!showTermsUS)} className='header sub-header'>
                        <h3>United States (US)</h3>
                        <div className='spacer' />
                        <span className='show-less-more'>Show {showTermsUS ? 'less -' : 'more +'}</span>
                    </div>
                    <div className='terms-doc' hidden={!showTermsUS}
                         dangerouslySetInnerHTML={{ __html: termsUS }} />
                </div>
            </div>
        </Card>
    </div>)
}
